import _ from 'lodash';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Loader } from '../../../components/Loader';
import { KanbanBoardColumn } from './column';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_COMPANY_PROPERTY_UPDATE } from '../../Companies/constants';

const Container = styled.div``;
/* eslint-disable react/prefer-stateless-function */
class KanbanBoardComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  get board() {
    return this.props.board;
  }

  render() {
    if (!this.board) return null;
    if (this.props.work) return <Loader small />;

    return (
      <Container>
        <HBox left stretch>
          {_(this.board.columns)
            .sortBy(column => column?.KanbanBoardHasKanBoardColumn?.sort_order)
            .map(column => (
              <KanbanBoardColumn
                key={column.id}
                board_id={this.board.id}
                column={column}
                hideOnEmpty={this.props.hideEmptyColumns}
                filter={this.props.filter}
                onChange={this.props.onChange}
              />
            ))
            .value()}
        </HBox>
      </Container>
    );
  }
}

KanbanBoardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    //  work: selectWorks([REQUEST_KANBAN_BOARDS]),
    work: selectWorks([REQUEST_COMPANY_PROPERTY_UPDATE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoard = compose(withConnect, withRouter)(KanbanBoardComp);
